import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faCircleArrowLeft, faFileContract, faHomeAlt, faPercent, faWrench } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-manage-property-menu',
    templateUrl: './manage-property-menu.component.html',
    styleUrls: ['./manage-property-menu.component.css'],
    standalone: false
})
export class ManagePropertyMenuComponent {

  faCircleArrowLeft = faCircleArrowLeft;
  faHomeAlt = faHomeAlt;
  faWrench = faWrench;
  faPercent = faPercent;
  faFileContract = faFileContract;

  constructor(private router: Router) { }

  goBack(): void {
    this.router.navigate(['/manage-property/view']);
  }

  goHome(): void {
    this.router.navigate(['/home']);
  }

  manageMaintenance(): void {
    this.router.navigate(['/generate-maintenance']);
  }

  manageRates(): void {
    this.router.navigate(['/manage-rates']);
  }

  manageLicense(): void {
    this.router.navigate(['/manage-subscription']);
  }
}
